import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { GlobalFieldProjectsUsage } from '../types.tsx';

export const getGlobalFieldProjectsUsageInfo = (
	fieldKey: string,
): Promise<GlobalFieldProjectsUsage> =>
	fetchJson<GlobalFieldProjectsUsage>(`/rest/polaris/global-fields/${fieldKey}/usage`);
